export const GET_ALL_SOLUTIONS = 'GET_ALL_SOLUTIONS';


